<template>
    <div class="combo-box">
        <div class="combo-box-current" :class="{ disabled: !active }" @click="toggleComboBox">
            <v-switch background-color="success" v-model="active" @click.native.stop></v-switch>
            <span class="selected-items">
                <template v-if="value ==null || isNaN(value) || value < 1">
                    {{ this.noItemsText }}
                </template>
                <template v-else>
                    At least {{value[0]}} quarter(s) connected
                </template>
            </span>
            <span class="combo-box-open-sign">
                <i v-if="!open" class="fa fa-plus"></i>
                <i v-else class="fa fa-minus"></i>
            </span>
        </div>
        <div class="combo-box-open" :class="{ open, disabled: !active }">

            <div class="combo-box-separator"></div>
            <div class="combo-box-items integer-input-box" >
                <v-text-field v-model="amount" type="number" label="Amount of Quarters Connected "
                              oninput="if(Number(this.value) <1) this.value = 1;"
                ></v-text-field>

            </div>

        </div>
    </div>
</template>

<script>


export default {
    props: {
        items: {
            type: Array,
            default: () => [],
        },
        value: {
            type: Array,
        },
        noItemsText: {
            type: String,
        },
        placeholder: {
            type: String,
        },
        filters: {
            type: Object,
        },
        open: {
            type: Boolean,
            default: false,
        },
        reset: {
            type: Boolean,
            default: false
        },

    },
    data() {
        return {
            active: true,
            amount:0,
        };
    },
    watch: {
        amount() {
            this.amount = parseInt(this.amount);
            this.$emit('input', [this.amount]);
        },
        value() {
            this.setDefaultSelectedValues();
        },
        filters() {
            this.closeComboBox();
        },
        active() {
            this.onActiveChange();
        },
        reset(){
             this.active = true;
        }
    },

    created() {
        this.setDefaultSelectedValues();
    },
    methods: {

        toggleComboBox() {
            if (this.active) {
                this.$emit('update:open', !this.open);
            }
        },
        closeComboBox() {
            this.$emit('update:open', false);
        },
        setDefaultSelectedValues() {
            this.amount = (this.value && this.value[0] && !Number.isNaN(this.value[0]) )  ? this.value[0] : 1;
        },


        onActiveChange() {
            if (!this.active) {
                this.closeComboBox();
            }

            this.$emit('toggleActive', this.active);
        },
    },
};

</script>

<style lang="scss">
    @import '../../style/common/IntegerInputBox.scss';
</style>
